import DatabaseModel from './DatabaseModel.js';

var Alerta = Object.create(DatabaseModel);

Alerta.model = 'alertas';
Alerta.modelFront = 'alertas';

Alerta.marcarLeida = function(id) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + id + '/leida',
        method: 'PUT',
        data: {}
    }, false);
};

Alerta.archivar = function(id) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + id + '/archivar',
        method: 'PUT',
        data: {}
    }, false);
};

Alerta.eliminarMultiples = function(ids) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/eliminar-multiples',
        method: 'POST',
        data: ids || []
    }, false);
};

Alerta.eliminar = function(id) {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/' + id,
        method: 'DELETE'
    }, false);
};

Alerta.mias = function(skip, limit, texto, soloNoLeidas, soloLeidas) {
    var self = this;
    var s = skip || 0;
    var l = limit || 20;
    var url = self.server_movilidad + self.prefix + self.model + '/mias?skip=' + s + '&limit=' + l;
    if (texto) url += '&texto=' + encodeURIComponent(texto);
    if (soloNoLeidas) url += '&soloNoLeidas=true';
    if (soloLeidas) url += '&soloLeidas=true';
    return self.sendRequest({
        url: url,
        method: 'GET'
    }, false);
};

Alerta.countNoLeidas = function() {
    var self = this;
    return self.sendRequest({
        url: self.server_movilidad + self.prefix + self.model + '/no-leidas/count',
        method: 'GET',
        data: {}
    }, false);
};

export default Alerta;
